export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11284.8b62a67b.jpg";